import React from 'react';
import MpiFourWheelInput from '../MpiFourWheelInput';
import MpiCustomRowInput from '../MpiCustomRowInput';
import MpiDefaultRow from '../MpiDefaultRow';

const RowTypeSelector = ({ item, handleCellEdit, canEditField, dynamicHeaders }) => {
  const hasNameColumn = dynamicHeaders?.some(h => h.field === 'name');

  if (item.layout_type === '4_wheel_input') {
    return <MpiFourWheelInput item={item} handleCellEdit={handleCellEdit} canEditField={canEditField} />;
  }

  if (item.name === 'custom' && !hasNameColumn) {
    return <MpiCustomRowInput item={item} handleCellEdit={handleCellEdit} canEditField={canEditField} />;
  }

  return <MpiDefaultRow item={item} />;
};

export default RowTypeSelector;